'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWeatherSnow = function TiWeatherSnow(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.2 25.2l-4.1-0.8 2.4-0.7c0.9-0.2 1.5-1.1 1.2-2-0.2-0.9-1.1-1.4-2-1.2l-2.5 0.7c0-0.4 0.1-0.8 0.1-1.2s-0.1-0.8-0.1-1.2l2.5 0.7c0.1 0 0.3 0.1 0.4 0.1 0.8 0 1.4-0.5 1.6-1.3 0.3-0.9-0.3-1.8-1.2-2l-2.4-0.7 4.1-0.8c0.3-0.1 0.7-0.3 0.9-0.6 0.7-0.7 0.6-1.8-0.1-2.5s-1.9-0.5-2.5 0.2l-2.8 3.1 0.7-2.5c0.2-0.8-0.3-1.8-1.2-2-0.9-0.2-1.8 0.3-2 1.2l-0.7 2.5c-0.6-0.5-1.3-0.9-2-1.2l1.8-1.8c0.6-0.7 0.6-1.7 0-2.4s-1.7-0.6-2.4 0l-1.8 1.8 1.4-3.9c0.1-0.4 0.1-0.8 0-1.1-0.4-1-1.3-1.5-2.3-1.2-0.9 0.4-1.4 1.3-1.1 2.3l1.3 3.9-1.8-1.8c-0.6-0.6-1.7-0.6-2.3 0s-0.7 1.7 0 2.4l1.8 1.8c-0.7 0.3-1.4 0.7-2 1.2l-0.7-2.5c-0.2-0.9-1.2-1.4-2-1.2-0.9 0.2-1.5 1.2-1.2 2l0.6 2.5-2.7-3.1c-0.3-0.3-0.6-0.5-1-0.6-0.9-0.2-1.9 0.5-2.1 1.4s0.5 1.9 1.4 2.1l4.1 0.8-2.5 0.7c-0.9 0.2-1.4 1.1-1.1 2 0.1 0.8 0.8 1.3 1.6 1.3 0.1 0 0.2-0.1 0.4-0.1l2.5-0.7c-0.1 0.4-0.1 0.8-0.1 1.2 0 0.4 0 0.8 0.1 1.2l-2.5-0.7c-0.9-0.2-1.8 0.3-2.1 1.2-0.2 0.9 0.3 1.8 1.2 2l2.5 0.7-4.1 0.8c-0.4 0.1-0.7 0.3-1 0.6-0.6 0.7-0.5 1.8 0.2 2.5 0.7 0.6 1.8 0.5 2.5-0.2l2.7-3.1-0.6 2.5c-0.3 0.8 0.3 1.8 1.2 2 0.1 0 0.3 0.1 0.4 0.1 0.7 0 1.4-0.5 1.6-1.3l0.7-2.5c0.6 0.5 1.3 0.9 2 1.2l-1.8 1.8c-0.7 0.7-0.7 1.7 0 2.4s1.7 0.6 2.3 0l1.2-1.2h0.4l-1.1 3.3c-0.1 0.4-0.1 0.8 0 1.1 0.3 1 1.3 1.5 2.2 1.2 1-0.4 1.5-1.3 1.2-2.3l-1.2-3.3h0.5l1.1 1.2c0.4 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c0.6-0.7 0.6-1.7 0-2.4l-1.8-1.8c0.7-0.3 1.4-0.7 2-1.2l0.7 2.5c0.2 0.8 0.8 1.3 1.6 1.3 0.1 0 0.3-0.1 0.4-0.1 0.9-0.2 1.4-1.2 1.2-2l-0.7-2.5 2.8 3.1c0.2 0.3 0.6 0.5 1 0.6 0.9 0.2 1.8-0.5 2-1.4 0.2-1-0.4-1.9-1.3-2.1z m-12.4-1c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2-1.9 4.2-4.2 4.2z' })
        )
    );
};

exports.default = TiWeatherSnow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/weather-snow.js
// module id = 3833
// module chunks = 0